import { pairBehaviorSubjects } from "core/rx-js";
import { BehaviorSubject } from "rxjs";
import { ClassControlOptionsMap } from "../control-options/types/class-control-options-map";
import { FormControlServiceMap } from "../types/form-control-service-map";
import { LControlType } from "../types/form-control.options-map";
export const FormControlUtils = {

  mapControlOptionsToService: <TControlType extends LControlType>(optionsInstance: ClassControlOptionsMap[TControlType], serviceInstance: FormControlServiceMap[TControlType]) => {

    if (!optionsInstance || !serviceInstance) {
      return null
    }

    const disposables = Object.entries(optionsInstance)
      .filter(([subjectKey, possibleSubject]) => possibleSubject instanceof BehaviorSubject && Boolean((<any>serviceInstance)[subjectKey]))
      .map(([subjectKey, subject]) => {

        const disposable = pairBehaviorSubjects(<BehaviorSubject<any>>subject, (<any>serviceInstance)[subjectKey]);
        return disposable;

      })

    return disposables;

  }
}
